import * as React from 'react';

import { IAdFoxBannerContext } from '@cian/adfox';
import { IPromoBanner, IPromoBlock } from '../../models/promo_block';
import { AdfoxLazy } from '../adfox/adfox_lazy';
import { adfoxJKConstants } from '../adfox/constants';
import { JkBlock } from '../promo_banner/jk_block';
import { Map } from '../promo_banner/map';
import { PromoBlock } from '../promo_block/promo_block';

const s = require('./promo_blocks.css');

interface IProps {
  promoBlocks: IPromoBlock[];
  promoBanner: IPromoBanner;
  isFetching: boolean;
  subdomainRegionId: number;
  onLinkClick(url: string): void;
}

export const PromoBlocks = (props: IProps) => {
  if (props.isFetching) {
    return <div></div>;
  }
  const bannerClass = `cg-col-${props.promoBanner.size} ${s['cg-col-promo-s-' + props.promoBanner.xsSize]} ` +
    `cg-col-xs-${props.promoBanner.xsSize}`;

  return (
    <div className={s['c-promo-container']}>
      <div className="cg-container-fluid-xs">
        <div className={`cg-row ${s['c-promo-count-' + props.promoBlocks.length]}`}>
          {
            props.promoBlocks.map((promoBlock: IPromoBlock, index: number) =>
              <PromoBlock
                key={promoBlock.promo.id}
                isMortgage={index === 0}
                promoBlock={promoBlock}
                onLinkClick={(url) => props.onLinkClick(url)}
                class={`cg-col-${promoBlock.size} ${s['cg-col-promo-s-' + promoBlock.xsSize]} `
                  + `cg-col-xs-${promoBlock.xsSize}`}
              />,
            )
          }
          {
            props.promoBanner.promo
              ? <AdfoxLazy
                    constants={adfoxJKConstants}
                    banner={(context: IAdFoxBannerContext) => {
                      if (context['title']) {
                        return (<JkBlock
                          {...context}
                          class={bannerClass}
                        />);
                      } else {
                        return (
                          <Map
                            class={bannerClass}
                            subdomainRegionId={props.subdomainRegionId}
                          />
                        );
                      }
                    }}
                    emptyBanner={() => (
                      <Map
                        class={bannerClass}
                        subdomainRegionId={props.subdomainRegionId}
                      />
                    )}
                    failureBanner={(error: Error) => (
                      <Map
                        class={bannerClass}
                        subdomainRegionId={props.subdomainRegionId}
                      />
                    )}
              />
              :   <Map
                    class={bannerClass}
                    subdomainRegionId={props.subdomainRegionId}
                  />
          }
        </div>
      </div>
    </div>
  );
};
